import https from "@/utils/https";
import axios from "axios";
import { RequestParams, ContentType, Method } from "axios-mapper";

// 上传素材
export const uploadAsset = (data: any, onUploadProgress: any) => {
  return https().httpClient.post(`ad/material/upload_file`, data, {
    onUploadProgress,
  });
};

// 获取素材列表
export const getMaterial = (params: any) => {
  return https()
    .httpClient.get(`ad/material`, { params })
    .then(res => res.data);
};

export const deleteMaterial = (id: number) => {
  return https().request(
    `ad/material?id=${id}`,
    Method.DELETE,
    undefined,
    ContentType.json
  );
};

// 获取广告方案列表
export const getAdScheme = (params: any) => {
  return https().request(`ad/scheme`, Method.GET, params, ContentType.form);
};

// 获取广告详情
export const getAdsDetail = (id:any) => {
  return https().request(`ad/scheme/detail?id=${id}`, Method.GET, undefined, ContentType.json);
};

// 获取广告方案投放记录
export const getAdsSyncRecord = (id: any) => {
  return https().request(`ad/scheme/sync/record?id=${id}`, Method.GET, undefined, ContentType.json);
};

// 新增广告方案
export const createAds = (data: any) => {
  return https().request(`ad/scheme`, Method.POST, data, ContentType.json);
};

// 删除广告方案
export const deleteAds = (id: any) => {
  return https().request(`ad/scheme?id=${id}`, Method.DELETE, undefined, ContentType.json);
};

// 编辑广告方案
export const updateAds = (data:any) => {
  return https().request(`ad/scheme`, Method.PUT, data, ContentType.json);
};

// 广告同步
export const syncScheme = (data:any) =>{
  return https().request(`ad/scheme/sync`, Method.POST, data, ContentType.json);
}

// 获取剩余空间
export const getSpace = () =>{
  return https().request(`ad/material/space`, Method.GET, undefined, ContentType.json);
}